var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpinner2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5 30.5C23.7843 30.5 30.5 23.7843 30.5 15.5C30.5 7.21573 23.7843 0.5 15.5 0.5C7.21573 0.5 0.5 7.21573 0.5 15.5C0.5 23.7843 7.21573 30.5 15.5 30.5ZM15.5003 26.0886C21.3481 26.0886 26.0886 21.3481 26.0886 15.5003C26.0886 9.65262 21.3481 4.91211 15.5003 4.91211C9.65262 4.91211 4.91211 9.65262 4.91211 15.5003C4.91211 21.3481 9.65262 26.0886 15.5003 26.0886Z",
    fill: "#BDD2E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3284 1.67864C23.0061 2.38613 24.5352 3.39067 25.845 4.63807C26.7274 5.47848 26.5465 6.87936 25.5858 7.62906C24.6257 8.37837 23.2516 8.18572 22.3204 7.40077C20.478 5.84788 18.0985 4.91211 15.5003 4.91211C9.65263 4.91211 4.91211 9.65263 4.91211 15.5003C4.91211 21.3481 9.65263 26.0886 15.5003 26.0886C15.6332 26.0886 15.7433 26.1935 15.7463 26.3264L15.791 28.2905C15.8187 29.5086 14.8488 30.5353 13.6398 30.3842C11.845 30.1599 10.0993 29.612 8.4895 28.761C6.22707 27.5649 4.30827 25.8099 2.91561 23.6629C1.52295 21.5159 0.702754 19.0483 0.533029 16.4948C0.363304 13.9413 0.8497 11.3869 1.94595 9.07446C3.0422 6.76203 4.71185 4.76852 6.79607 3.28356C8.8803 1.7986 11.3098 0.871568 13.8534 0.590651C16.3971 0.309734 18.9703 0.684272 21.3284 1.67864Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinner2);
export default __webpack_public_path__ + "static/media/Spinner2.539d329b6e3484312b23947a9e926d81.svg";
export { ForwardRef as ReactComponent };